import { Box, Skeleton, Stack } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";

export const TransactionItemSkeleton = () => (
  <Box
    width="100%"
    mt={2.5}
    pb={1.5}
    borderBottom={`1px solid ${Colors.MediumGrey}`}
  >
    <Box display="flex" justifyContent="space-between">
      <Box display="flex" alignItems="center" gap={4}>
        <Skeleton variant="rounded" width={24} height={24} />
        <Stack gap={0.5}>
          <Skeleton variant="text" width={100} height={21} />
          <Skeleton variant="text" width={80} height={18} />
        </Stack>
      </Box>
      <Box display="flex" alignItems="center">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          gap={0.5}
        >
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={60} height={16} />
        </Box>
      </Box>
    </Box>
  </Box>
);
